// @flow
import * as React from 'react'
import { getStaticSlugsPaths } from '../../../helpers/nextHelpers'
import type { SlugsStaticType } from '../../../helpers/nextHelpers'
import { withRouter } from 'next/router'
import {
  getTrackDetailPropsAsync,
  getTrackSlugsAsync
} from '../../../models/Track'
import type { TrackDetailPropsType } from '../../../models/Track'
import DiscoverLayout from '@components/Discover/DiscoverLayout'
import { TrackDetail } from '@components/Track/TrackDetail'
import type { TagInfoType } from '../../../models/Tag'
function TrackDetailPage (props: TrackDetailPropsType): React.Node {
  const firstThreeTags = props.track.tags.slice(0, 3).map((tag: TagInfoType): string => tag.title).join('. ')
  return (
    <DiscoverLayout
      background
      mobileBackgroundXS={false}
      title={`Listen to ${props.track.title} on Dipsea`}
      imageUrl={props.track.images.img500}
      description={`Listen to ${props.track.title} on Dipsea. ${firstThreeTags}. ${props.track.description}`}
      canonicalUrl={`https://www.dipseastories.com${props.track.slug.replace('/stories', '/chapters')}`}
    >
      <TrackDetail {...props}/>
    </DiscoverLayout>
  )
}
export default withRouter(TrackDetailPage)

type ContextType = {
  params: {
    slug: string
  }
}

export async function getStaticProps (
  context: ContextType
): Promise<{ props: TrackDetailPropsType }> {
  const track = await getTrackDetailPropsAsync(context.params.slug)
  return { props: track }
}
export async function getStaticPaths (): Promise<SlugsStaticType> {
  const slugs = await getTrackSlugsAsync()
  return getStaticSlugsPaths(slugs)
}
